import React, { Component } from "react";
import {
  TableHeaderWrapper,
  PurchasedDate,
  Description,
  TotalCost,
  PaymentMethod,
  Status,
  Receipt,
  CancelOrRefund
} from "./TableHeader.style";
import i18n from '../../../../i18n'
export class TableHeader extends Component {
  render() {
    return (
      <TableHeaderWrapper>
        <PurchasedDate>{this.props.purchasedate?this.props.purchasedate :i18n.t("orderhistory.header.title1")}</PurchasedDate>
        <Description>{i18n.t("orderhistory.header.title2")}</Description>
        <TotalCost>{i18n.t("orderhistory.header.title3")}</TotalCost>
        <Status>{i18n.t("orderhistory.header.title4")}</Status>
        <Receipt>{i18n.t("orderhistory.header.title5")}</Receipt>
        <CancelOrRefund>{i18n.t("orderhistory.header.title6")}</CancelOrRefund>
      </TableHeaderWrapper>
    );
  }
}
